import React from 'react';
import cx from 'classnames';
import MenuToggle from './MenuToggle';

class Header extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {

        let activeRouteClass = ["skills", "portofolio", "blog", "contact", "/"].filter((r) => this.props.className.includes(r));
        let title;
        switch (activeRouteClass[0]) {
            case "/":
                title = 'Adrian Manduc';
                break;
            case 'portofolio':
                title = 'My Work';
                break;
            case 'skills':
                title = "Skills & Experience";
                break;
            case 'blog':
                title = "Skills & Experience";
                break;
            case undefined:
                title = "Woops";
                break;
            default:
                title = "Woops";
        }

        let headerClassNames = cx('header', activeRouteClass, {
            'scrolled': this.props.scrolled,
            'menu-active': this.props.menuActive,

        });
        return (
            <header className={headerClassNames}>
                <div className='title-wrapper'>
                    <a className="title"> {title} </a>
                    <div className="cv-download-wrapper"><a href="https://drive.google.com/file/d/1WaA6915j-skXkM1368EiCMbYWCVCt3wA/view?usp=sharing" target="_blank"><i className="fa fa-download"></i> CV</a></div>
                </div>

                <MenuToggle toggle={this.props.toggleMenu}></MenuToggle>
            </header>
        );
    }
}

export default Header;

/* const Header = (props) => {
    let headerClassNames = cx('header', {
        'scrolled': props.scrolled,
        'menu-active': props.menuActive
    });
    return (
        <header className={headerClassNames}>
            <div className='title-wrapper'>
                <a className="title"> Adrian Manduc </a>
            </div>
            <MenuToggle toggle={props.toggleMenu}></MenuToggle>
        </header>
    );
} */



// WEBPACK FOOTER //
// ./src/components/Navigation/Header.js